// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    baseUrl: 'http://localhost:4200',
    keycloakRealm: 'corpay',
    keycloakClient: 'corpay-ui',
    keycloakBaseUrl: 'https://secure-ng-ui-master.kryptonite.progressoft.cloud'

};
window['APP_URL'] = 'https://api-ng-ui-master.kryptonite.progressoft.cloud/';



